"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CaseStudiesIntroduction() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: underlineRef,
    isVisible: underlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.5
  });
  return <section className="bg-background py-16 px-6 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-3xl text-center">
        <div ref={contentRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h1 className="font-sans text-4xl font-bold text-foreground sm:text-5xl lg:text-6xl mb-6">
            Innovation in Action
          </h1>
          
          <p className="text-muted text-lg sm:text-xl leading-relaxed">Discover how Flex R&amp;D transforms bold concepts into market-ready products through advanced materials, cutting-edge technologies, and strategic expertise.</p>
        </div>

        <div ref={underlineRef} className="mt-8 flex justify-center" aria-hidden="true">
          <svg width="120" height="8" viewBox="0 0 120 8" fill="none" xmlns="http://www.w3.org/2000/svg" className="overflow-visible">
            <path d="M0 4 H120" stroke="hsl(215, 80%, 48%)" strokeWidth="3" strokeLinecap="round" className={`transition-all duration-[400ms] ease-[var(--ease-out-back)] ${underlineVisible ? "opacity-100 [stroke-dashoffset:0]" : "opacity-0 [stroke-dashoffset:120]"}`} style={{
            strokeDasharray: "120",
            strokeDashoffset: underlineVisible ? "0" : "120"
          }} />
          </svg>
        </div>
      </div>
    </section>;
}